import { CommonModule } from '@angular/common';
import { NgModule, Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

import { consumeEvent } from '@eui/core';
import { EuiDropdownContentModule } from './components/eui-dropdown-content.component';
import { BaseDirective } from '../../base.directive';

@Component({
    selector: 'eui-dropdown',
    templateUrl: './eui-dropdown.component.html',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiDropdownComponent extends BaseDirective {
    @Input() e2eAttr = 'eui-dropdown';
    @Input() tabIndex = -1;     // Skip it for tab navigation
    @Input() width = 'auto';

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-dropdown'),
        ].join(' ').trim();
    }

    constructor() {
        super();
    }

    onClicked(event: Event) {
        consumeEvent(event);
    }
}

/* ***************************************** */
/* MODULE EXPORT */
/* ***************************************** */
@NgModule({
    imports: [
        CommonModule,
        MatMenuModule,
        EuiDropdownContentModule,
    ],
    declarations: [
        EuiDropdownComponent,
    ],
    exports: [
        EuiDropdownComponent,
        EuiDropdownContentModule,
    ],
})
export class EuiDropdownModule { }
